import styled, { css } from 'styled-components';
import ReactSelect from 'react-select';

interface SelectProps {
  isErrored: boolean;
  isFocused: boolean;
}

export const Title = styled.div`
  display: flex;

  font-weight: 600;
  margin-bottom: 5px;

  span {
    color: ${props => props.theme.colors.grey1};
    font-size: 16px;
  }

  strong {
    color: ${props => props.theme.colors.red};
    font-size: 20px;
    margin-left: 3px;
  }
`;

export const Select = styled(ReactSelect)<SelectProps>`
  background: none;
  border-radius: 60px;
  min-width: 75px;
  font-size: 16px;
  font-weight: 600;

  > div:first-child {
    padding: 15px 19px !important;
    width: 100%;
  }

  div {
    box-shadow: 0 0 0 !important;

    div > input {
      color: #000 !important;
    }
  }

  .react-select__control {
    border: 1px solid ${props => props.theme.colors.grey3} !important;
    padding: 7px 15px !important;

    ${props =>
      props.isErrored &&
      css`
        border: 1px solid ${props.theme.colors.danger} !important;
      `}
  }

  .react-select__control--is-focused {
    border: 1px solid ${props => props.theme.colors.primary};
  }

  .react-select__value-container {
    padding: 0 0 !important;
    margin: 0 0 !important;
  }

  .react-select__indicator.react-select__dropdown-indicator.css-tlfecz-indicatorContainer {
    padding-right: 0px;
  }

  .react-select__option {
    font-size: 14px;
  }

  .react-select__placeholder {
    color: ${props => props.theme.colors.grey3};
  }
`;
